var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { UploadService } from 'src/app/bpg-self-services/d-i/upload.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { BpgAdminServices } from 'src/app/bpg-admin/bpg-admin-services';
import { NgSelectComponent } from '@ng-select/ng-select';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
var PushNotificationComponent = /** @class */ (function () {
    function PushNotificationComponent(spinner, router, selfService, bpgCommonService, dialog, uploadService, bpgAdminServices, cdr) {
        this.spinner = spinner;
        this.router = router;
        this.selfService = selfService;
        this.bpgCommonService = bpgCommonService;
        this.dialog = dialog;
        this.uploadService = uploadService;
        this.bpgAdminServices = bpgAdminServices;
        this.cdr = cdr;
        this.review = null;
        this.recipientRequestId = 0;
        this.siteRequestId = 0;
        this.manualEmails = [];
        this.attachmentWarnings = [];
        this.recipientsLoadError = false;
        this.sendStatus = '';
        this.adminId = localStorage.getItem('adminId');
        this.timeoutErrorMessage = ConstantValues.timeoutErrorMessage;
        this.timeOutError = false;
        this.chapterNotification = '';
        this.chapterList = [];
        this.notificationSuccess = false;
        this.notificationFailure = false;
        this.fileSizeConstant = "Upload document(< 500MB)";
        this.fileName = this.fileSizeConstant;
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.fileSize = 0;
        this.fileList = [];
        this.removeToolbarHeaders = { disableNativeSpellChecker: false, autoParagraph: false, toolbar: 'Basic', extraPlugins: 'colorbutton', uiColor: '#FFFFFF', basicEntities: false, fillEmptyBlocks: false, removeButtons: 'Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Strike,Subscript,Superscript,RemoveFormat', height: '300px', maxLength: '4000', Backgroundcolor: 'black !important' };
        this.selectedSiteIds = [];
        this.emailList = [];
        this.memberUserId = [];
        this.selectedEmail = [];
        this.copySuccess = false;
        this.copyFailure = false;
        this.recipientsLoading = false;
        this.peopleSearchLoading = false;
        this.isSending = false;
        this.userList = [];
        this.customSearchFn = function () { return true; };
        this.selectedUserList = [];
        this.selectedEmailString = '';
        this.showCustomDateRange = false;
        this.todaysDate = new Date();
        this.maxDate = new Date();
        this.showJoinedDateField = false;
        this.countOfSignedUser = 10;
        this.limit = ConstantValues.pageLimit;
        this.noMemberFound = false;
        this.startDateGreaterError = false;
        this.isbpgAdmin = false;
        this.isbpgLeadAdmin = false;
        this.selectAllConstant = 'Select All';
        this.recipientType = 'MEMBERS';
        this.allSitesSelected = false;
    }
    PushNotificationComponent.prototype.ngOnInit = function () {
        var savedLoginData = localStorage.getItem('loginData');
        try {
            this.loginData = savedLoginData ? JSON.parse(savedLoginData) : null;
        }
        catch (_error) {
            this.loginData = null;
        }
        if (!this.loginData || this.loginData.userId === undefined || this.loginData.userId === null) {
            this.router.navigate(['/log-out']);
            return;
        }
        this.loginDetails = this.loginData;
        this.loginUserId = this.loginData.userId;
        if (localStorage.getItem('isbpgAdmin') === 'true') {
            this.isbpgAdmin = true;
        }
        if (localStorage.getItem('isbpgLeadAdmin') === 'true') {
            this.isbpgLeadAdmin = true;
        }
        if (this.adminId !== "1" && this.adminId !== "2" && this.adminId !== "3" && !this.isbpgAdmin && !this.isbpgLeadAdmin) {
            this.router.navigate(['/site-home']);
        }
        this.userAndRoleIdDTO = {
            userId: this.loginData['userId'],
            roleId: localStorage.getItem('adminId')
        };
        this.bpgCommonService.getSessionToken();
        this.logUserAction();
        if (this.chapterNotification != null && this.chapterNotification !== undefined && this.chapterNotification !== '') {
            this.chapterNotificationSuccess = true;
        }
        if (this.chapterNotification === null || this.chapterNotification === undefined || this.chapterNotification === '') {
            this.chapterNotificationSuccess = false;
        }
        this.filterList =
            [{ filterId: 1, filterName: 'All' },
                { filterId: 2, filterName: 'Custom Date Range' },
                { filterId: 3, filterName: 'Last 7 days' },
                { filterId: 4, filterName: 'Last 30 days' },
                { filterId: 5, filterName: 'Last 6 Months' },
                { filterId: 6, filterName: 'Last 12 Months' }];
        this.getAllErgs();
    };
    PushNotificationComponent.prototype.ngOnDestroy = function () {
        this.recipientRequestId++;
        this.siteRequestId++;
        if (this.reviewDialogRef) {
            this.reviewDialogRef.close();
        }
    };
    PushNotificationComponent.prototype.getAllErgs = function () {
        var _this = this;
        var landingDto = {
            "filter": {},
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 0,
            "sortDirection": "ASC",
            "sortProperty": "",
            "uid": ""
        };
        this.spinner.show();
        this.selfService.getAllBpg(landingDto).subscribe(function (data) {
            _this.bpgList = data;
            _this.bpgList.unshift({ bpgId: 0, bpgName: _this.selectAllConstant });
            _this.spinner.hide();
        }, function () {
            _this.spinner.hide();
        });
    };
    /** For fetching site list
    * @class PushNotificationComponent
    * @method siteChange
    */
    PushNotificationComponent.prototype.bpgChange = function (event) {
        var _this = this;
        var requestId = ++this.siteRequestId;
        this.clearAudienceRecipients();
        this.selectedEmail = [];
        this.selectedFilter = 1;
        this.startDate = null;
        this.endDate = null;
        this.noMemberFound = false;
        this.copySuccess = false;
        this.copyFailure = false;
        this.usersAdded = false;
        this.selectedSiteIds = [];
        this.memberUserId = [];
        this.emailList = [];
        this.siteId = null;
        this.siteList = [];
        this.recipientType = 'MEMBERS';
        this.allSitesSelected = false;
        this.bpgId = event ? event.bpgId : null;
        if (this.bpgId === null || this.bpgId === undefined) {
            return;
        }
        if (Number(this.bpgId) === 0) {
            var selectAllSite = { siteId: 0, siteName: this.selectAllConstant };
            this.siteList = [selectAllSite];
            this.siteId = [selectAllSite];
            this.selectedSiteIds = [0];
            this.allSitesSelected = true;
            this.getChapterMembersEmails();
            return;
        }
        this.selectedBpgsData =
            {
                "filter": {
                    "bpgId": this.bpgId,
                    "userId": this.userAndRoleIdDTO.userId,
                    "adminId": this.userAndRoleIdDTO.roleId
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "string",
                "searchTerm": "string",
                "size": 0,
                "sortDirection": "ASC",
                "sortProperty": "string",
                "uid": "string"
            };
        this.siteList = [];
        this.spinner.show();
        this.bpgCommonService.getMySiteList(this.selectedBpgsData).subscribe(function (data) {
            if (requestId !== _this.siteRequestId) {
                return;
            }
            _this.siteList = data;
            _this.siteList.unshift({ siteId: 0, siteName: _this.selectAllConstant });
            _this.spinner.hide();
        }, function () {
            if (requestId !== _this.siteRequestId) {
                return;
            }
            _this.spinner.hide();
        });
    };
    PushNotificationComponent.prototype.siteChange = function (e) {
        var _this = this;
        this.clearAudienceRecipients();
        this.noMemberFound = false;
        this.copySuccess = false;
        this.copyFailure = false;
        this.usersAdded = false;
        var selectedSites = e || [];
        this.allSitesSelected = selectedSites.some(function (site) { return Number(site.siteId) === 0; });
        if (Number(this.bpgId) === 0) {
            var selectAllSite = selectedSites.find(function (site) { return Number(site.siteId) === 0; });
            this.siteId = selectAllSite ? [selectAllSite] : [];
            this.selectedSiteIds = selectAllSite ? [0] : [];
            if (selectAllSite) {
                this.getChapterMembersEmails();
            }
            else {
                this.selectedEmail = [];
                this.emailList = [];
            }
            return;
        }
        this.siteId = selectedSites;
        for (var _i = 0, selectedSites_1 = selectedSites; _i < selectedSites_1.length; _i++) {
            var i = selectedSites_1[_i];
            if (i.siteId === 0 && i.siteName === this.selectAllConstant) {
                this.siteId = this.siteList.filter(function (site) { return site.siteName !== _this.selectAllConstant; });
                break;
            }
        }
        if (this.siteId != null && this.bpgId != null && this.siteList.length > 0) {
            this.selectedSiteIds = [];
            if (this.siteId.length > 0) {
                for (var _a = 0, _b = this.siteId; _a < _b.length; _a++) {
                    var site = _b[_a];
                    this.selectedSiteIds.push(site.siteId);
                }
            }
            this.getChapterMembersEmails();
        }
    };
    PushNotificationComponent.prototype.getChapterMembersEmails = function () {
        var _this = this;
        this.clearAudienceRecipients();
        var requestId = this.recipientRequestId;
        this.noMemberFound = false;
        this.startDateGreaterError = false;
        this.recipientsLoading = false;
        if (this.allSitesSelected && this.recipientType === 'MEMBERS') {
            this.recipientType = 'ERG_ADMIN';
            this.resetJoinedDateFilter();
        }
        if (this.selectedFilter === 2 && (!this.startDate || !this.endDate)) {
            this.showCustomDateRange = true;
            this.emailList = [];
            this.selectedEmail = [];
            return;
        }
        else if (this.selectedFilter === 2 && this.startDate != null && this.endDate != null && this.endDate < this.startDate) {
            this.startDateGreaterError = true;
        }
        else {
            if (this.selectedSiteIds.length === 0) {
                return;
            }
            this.recipientsLoading = true;
            this.emailList = [];
            this.selectedEmail = [];
            this.spinner.show();
            if (this.showJoinedDateField) {
                if (this.selectedFilter !== 2 || (this.selectedFilter === 2 && this.startDate != null && this.endDate != null)) {
                    if (this.selectedFilter !== 2) {
                        this.startDate = null;
                        this.endDate = null;
                        this.showCustomDateRange = false;
                    }
                }
            }
            if (this.showJoinedDateField === false) {
                this.selectedFilter = 0;
                this.startDate = null;
                this.endDate = null;
            }
            this.allSiteIds = this.selectedSiteIds.toString();
            if (this.recipientType !== 'MEMBERS') {
                this.filterEmailsByAdminRole();
                return;
            }
            this.selectedBpgsData =
                {
                    "filter": {
                        "bpgId": this.bpgId,
                        "userId": 0,
                        "siteId": Number(this.bpgId) === 0 ? '0' : this.allSiteIds,
                        "filterId": this.selectedFilter,
                        'startDate': this.startDate,
                        'endDate': this.endDate
                    },
                    "moduleId": 0,
                    "page": 0,
                    "presentRole": "string",
                    "searchTerm": "string",
                    "size": 0,
                    "sortDirection": "ASC",
                    "sortProperty": "string",
                    "uid": "string"
                };
            this.bpgCommonService.getChapterEmailList(this.selectedBpgsData).subscribe(function (data) {
                if (requestId !== _this.recipientRequestId) {
                    return;
                }
                var emails = new Set();
                _this.emailList = (data || []).filter(function (email) {
                    var key = (email.emailId || '').trim().toLowerCase();
                    if (!key || emails.has(key)) {
                        return false;
                    }
                    emails.add(key);
                    return true;
                }).map(function (email) { return (__assign({}, email, { emailId: email.emailId.trim() })); });
                _this.selectedEmail = _this.emailList.map(function (email) { return email.emailId; });
                _this.noMemberFound = _this.emailList.length === 0;
                _this.recipientsLoading = false;
                _this.spinner.hide();
            }, function () {
                if (requestId !== _this.recipientRequestId) {
                    return;
                }
                _this.recipientsLoadError = true;
                _this.recipientsLoading = false;
                _this.spinner.hide();
            });
        }
    };
    /** loads emailList/selectedEmail for ERG Admins or ERG Lead Admins
    * from the chapter admin roster
    * @class PushNotificationComponent
    * @method filterEmailsByAdminRole
    */
    PushNotificationComponent.prototype.filterEmailsByAdminRole = function () {
        var _this = this;
        var requestId = this.recipientRequestId;
        this.recipientsLoading = true;
        if (this.selectedSiteIds.length === 0) {
            this.selectedEmail = [];
            this.noMemberFound = true;
            this.recipientsLoading = false;
            this.spinner.hide();
            return;
        }
        var selectedBpg = (this.bpgList || []).find(function (bpg) { return String(bpg.bpgId) === String(_this.bpgId); });
        var selectedSiteNames = new Set((this.siteList || [])
            .filter(function (site) { return _this.selectedSiteIds.some(function (siteId) { return String(siteId) === String(site.siteId); }); })
            .map(function (site) { return site.siteName; }));
        var adminFilterDto = {
            "filter": {
                "createdBy": this.loginUserId,
                "adminId": this.userAndRoleIdDTO.roleId,
                "bpgId": this.bpgId,
                "siteId": '0'
            },
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 1000,
            "sortDirection": "ASC",
            "sortProperty": "user_first_name",
            "uid": ""
        };
        var wantedRoleId = this.recipientType === 'ERG_LEAD_ADMIN' ? 2 : 3;
        var isGlobalSelection = Number(this.bpgId) === 0 &&
            this.selectedSiteIds.length === 1 && Number(this.selectedSiteIds[0]) === 0;
        this.getAllChapterAdminPages(adminFilterDto).subscribe(function (admins) {
            if (requestId !== _this.recipientRequestId) {
                return;
            }
            var emails = new Set();
            var scopedAdmins = admins.filter(function (admin) {
                return Number(admin.adminId) === wantedRoleId &&
                    (isGlobalSelection || (selectedBpg && admin.bpgName === selectedBpg.bpgName && selectedSiteNames.has(admin.siteName)));
            });
            _this.emailList = scopedAdmins.filter(function (admin) {
                var key = (admin.emailId || '').trim().toLowerCase();
                if (!key || emails.has(key)) {
                    return false;
                }
                emails.add(key);
                return true;
            }).map(function (admin) { return ({
                userId: admin.userId,
                emailId: admin.emailId.trim()
            }); });
            _this.selectedEmail = _this.emailList.map(function (admin) { return admin.emailId; });
            _this.noMemberFound = _this.emailList.length === 0;
            _this.recipientsLoading = false;
            _this.spinner.hide();
        }, function () {
            if (requestId !== _this.recipientRequestId) {
                return;
            }
            _this.recipientsLoadError = true;
            _this.recipientsLoading = false;
            _this.spinner.hide();
        });
    };
    PushNotificationComponent.prototype.getAllChapterAdminPages = function (adminFilterDto, page, accumulated) {
        var _this = this;
        if (page === void 0) { page = 0; }
        if (accumulated === void 0) { accumulated = []; }
        var request = __assign({}, adminFilterDto, { page: page });
        return this.bpgAdminServices.getAllChapterAdmins(request).pipe(switchMap(function (data) {
            var admins = accumulated.concat(data && data.content ? data.content : []);
            var pageSize = Number(request.size) || 1;
            var totalPages = data && data.totalPages !== undefined
                ? Number(data.totalPages)
                : Math.ceil(Number(data && data.totalElements !== undefined ? data.totalElements : admins.length) / pageSize);
            return page + 1 < totalPages
                ? _this.getAllChapterAdminPages(adminFilterDto, page + 1, admins)
                : of(admins);
        }));
    };
    PushNotificationComponent.prototype.clearAudienceRecipients = function () {
        this.recipientRequestId++;
        this.selectedEmail = [];
        this.emailList = [];
        this.manualEmails = [];
        this.recipientsLoading = false;
        this.recipientsLoadError = false;
        this.spinner.hide();
    };
    PushNotificationComponent.prototype.onRecipientTypeChange = function () {
        if (this.recipientType !== 'MEMBERS') {
            this.resetJoinedDateFilter();
        }
        this.getChapterMembersEmails();
    };
    Object.defineProperty(PushNotificationComponent.prototype, "noRecipientFoundMessage", {
        get: function () {
            if (this.recipientType === 'ERG_ADMIN') {
                return 'No ERG admins found.';
            }
            if (this.recipientType === 'ERG_LEAD_ADMIN') {
                return 'No ERG lead admins found.';
            }
            return 'No chapter members found.';
        },
        enumerable: true,
        configurable: true
    });
    PushNotificationComponent.prototype.buildAudienceSummaryParts = function () {
        var _this = this;
        var erg = (this.bpgList || []).find(function (bpg) { return String(bpg.bpgId) === String(_this.bpgId); });
        var ergSelected = Number(this.bpgId) === 0 && this.bpgId != null ? 'All ERGs' : (erg ? erg.bpgName : null);
        var sites = this.allSitesSelected ? 'All Sites' : (this.siteId || []).map(function (site) { return site.siteName; }).join(', ');
        var role = this.recipientType === 'ERG_ADMIN' ? 'ERG Admins'
            : this.recipientType === 'ERG_LEAD_ADMIN' ? 'ERG Lead Admins' : 'Members';
        var parts = [ergSelected
                ? { text: ergSelected, placeholder: false }
                : { text: 'Choose an ERG', placeholder: true }];
        if (sites) {
            parts.push({ text: sites, placeholder: false });
        }
        parts.push({ text: role, placeholder: false });
        if (this.showJoinedDateField && this.recipientType === 'MEMBERS') {
            var filter = (this.filterList || []).find(function (item) { return item.filterId === _this.selectedFilter; });
            if (this.selectedFilter === 2 && this.startDate && this.endDate) {
                parts.push({ text: "Joined " + this.startDate.toLocaleDateString() + " to " + this.endDate.toLocaleDateString(), placeholder: false });
            }
            else if (filter) {
                parts.push({ text: "Joined: " + filter.filterName, placeholder: false });
            }
            else {
                parts.push({ text: 'Choose a joined-date filter', placeholder: true });
            }
        }
        return parts;
    };
    Object.defineProperty(PushNotificationComponent.prototype, "audienceSummary", {
        get: function () {
            return this.buildAudienceSummaryParts().map(function (part) { return part.text; }).join(' › ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PushNotificationComponent.prototype, "selectedManualCount", {
        get: function () {
            var _this = this;
            return this.selectedEmail.filter(function (email) { return _this.isManualEmail(email); }).length;
        },
        enumerable: true,
        configurable: true
    });
    PushNotificationComponent.prototype.isManualEmail = function (email) {
        return this.manualEmails.indexOf(email.trim().toLowerCase()) !== -1;
    };
    PushNotificationComponent.prototype.visibleMessage = function (body) {
        var document = new DOMParser().parseFromString(body || '', 'text/html');
        document.querySelectorAll('script, style').forEach(function (element) { return element.remove(); });
        return (document.body.textContent || '').replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
    };
    PushNotificationComponent.prototype.validateNotification = function (draft) {
        var blockers = [];
        if (draft.bpgId === null || draft.bpgId === undefined) {
            blockers.push('select an ERG');
        }
        if (!draft.siteIds.length) {
            blockers.push('select at least one site');
        }
        if (!draft.subject || !draft.subject.trim()) {
            blockers.push('add a subject');
        }
        else if (draft.subject.length > 500) {
            blockers.push('shorten the subject (max 500 characters)');
        }
        if (!this.visibleMessage(draft.body)) {
            blockers.push('write a message');
        }
        if (draft.body && draft.body.length > 4000) {
            blockers.push('shorten the message (max 4000 characters including formatting)');
        }
        if (!draft.emails.length) {
            blockers.push('select at least one recipient');
        }
        if (draft.files.reduce(function (size, file) { return size + file.size; }, 0) > 524288000) {
            blockers.push('remove attachments to stay within the 500 MB total limit');
        }
        return blockers;
    };
    Object.defineProperty(PushNotificationComponent.prototype, "sendBlockers", {
        /** Shared by the review button and its handler; send validates the reviewed snapshot. */
        get: function () {
            var blockers = this.validateNotification({
                subject: this.subject, body: this.chapterNotification, bpgId: this.bpgId,
                siteIds: this.selectedSiteIds, emails: this.selectedEmail, files: this.fileList
            });
            if (this.recipientsLoading) {
                blockers.push('wait for recipients to finish loading');
            }
            if (this.recipientsLoadError) {
                blockers.push('retry loading recipients');
            }
            if (this.showJoinedDateField && this.recipientType === 'MEMBERS') {
                if (this.selectedFilter === null || this.selectedFilter === undefined) {
                    blockers.push('choose a joined-date filter option');
                }
                else if (this.selectedFilter === 2) {
                    if (!this.startDate || !this.endDate) {
                        blockers.push('choose a start and end date');
                    }
                    else if (isNaN(new Date(this.startDate).getTime()) || isNaN(new Date(this.endDate).getTime())) {
                        blockers.push('choose valid dates');
                    }
                    else if (this.startDate > this.endDate) {
                        blockers.push('fix the date range (start date must be on or before end date)');
                    }
                    else if (this.startDate > new Date() || this.endDate > new Date()) {
                        blockers.push('choose dates on or before today');
                    }
                }
            }
            return blockers;
        },
        enumerable: true,
        configurable: true
    });
    PushNotificationComponent.prototype.sendEmail = function () {
        this.selectedEmailString = this.selectedEmail.join(',');
        window.location.assign("mailto:" + this.selectedEmailString);
    };
    PushNotificationComponent.prototype.copyText = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.copySuccess = false;
                        this.copyFailure = false;
                        this.selectedEmailString = this.selectedEmail.join(';');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        if (!navigator.clipboard || !navigator.clipboard.writeText) {
                            throw new Error('Clipboard API unavailable');
                        }
                        return [4 /*yield*/, navigator.clipboard.writeText(this.selectedEmailString)];
                    case 2:
                        _a.sent();
                        this.copySuccess = true;
                        setTimeout(function () { return _this.copySuccess = false; }, 3000);
                        return [3 /*break*/, 4];
                    case 3:
                        _error_1 = _a.sent();
                        this.copyFailure = true;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PushNotificationComponent.prototype.showJoinedDateFilter = function () {
        var nextShowJoinedDateField = !this.showJoinedDateField;
        this.resetJoinedDateFilter();
        if (nextShowJoinedDateField) {
            this.showJoinedDateField = true;
            this.selectedFilter = 1;
        }
        if (this.selectedSiteIds.length > 0) {
            this.getChapterMembersEmails();
        }
    };
    /** the joined-date filter only applies to Members; other recipient types ignore it entirely */
    PushNotificationComponent.prototype.resetJoinedDateFilter = function () {
        this.startDateGreaterError = false;
        this.showJoinedDateField = false;
        this.selectedFilter = 0;
        this.startDate = null;
        this.endDate = null;
        this.showCustomDateRange = false;
    };
    PushNotificationComponent.prototype.removeText = function () {
        this.selectedEmail = [];
        this.emailList = [];
        this.manualEmails = [];
        this.copySuccess = false;
        this.copyFailure = false;
        this.usersAdded = false;
    };
    PushNotificationComponent.prototype.openAndCloseMatDialog = function (type) {
        var _this = this;
        if (type === 'open') {
            this.usersAdded = false;
            this.userExists = false;
            this.noUser = false;
            var dialogConfig = new MatDialogConfig();
            dialogConfig.width = '760px';
            dialogConfig.maxWidth = 'calc(100vw - 32px)';
            dialogConfig.maxHeight = 'calc(100vh - 32px)';
            dialogConfig.autoFocus = false;
            dialogConfig.ariaLabelledBy = 'add-people-dialog-title';
            dialogConfig.panelClass = 'pn-dialog-panel';
            dialogConfig.backdropClass = 'pn-dialog-backdrop';
            var dialogRef = this.dialog.open(this.callAPIDialog, dialogConfig);
            dialogRef.afterOpened().subscribe(function () {
                if (_this.userSelect) {
                    _this.userSelect.focus();
                }
            });
            dialogRef.afterClosed().subscribe(function () { return _this.resetAddPeopleDialogState(); });
        }
        else {
            this.dialog.closeAll();
        }
    };
    PushNotificationComponent.prototype.resetAddPeopleDialogState = function () {
        this.userFound = false;
        this.noUser = false;
        this.searchTerm = null;
        this.userList = [];
        this.selectedUserList = [];
        this.userExists = false;
        this.userFirstName = '';
        this.search = false;
        this.peopleSearchLoading = false;
    };
    PushNotificationComponent.prototype.searchBy = function () {
        this.userExists = false;
        this.search = true;
        this.searchTerm = (this.searchTerm) ? this.searchTerm : '';
        this.getUserList();
    };
    /** to list users other than admins
  * @class AdminComponent
  * @method getUserList
  */
    PushNotificationComponent.prototype.getUserList = function () {
        var _this = this;
        this.timeOutError = false;
        this.peopleSearchLoading = true;
        this.spinner.show();
        this.selectedBpgsData =
            {
                "filter": {
                    "leadershipPosition": "USER"
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "",
                "searchTerm": this.searchTerm,
                "size": 10,
                "sortDirection": "ASC",
                "sortProperty": "um.user_first_name",
                "uid": "string"
            };
        this.selfService.getUserDropDown(this.selectedBpgsData).subscribe(function (data) {
            _this.userList = data;
            _this.cdr.detectChanges();
            if (_this.userList.length === 0) {
                _this.noUser = true;
                _this.userFound = false;
            }
            else {
                if (_this.search) {
                    _this.userFound = true;
                    _this.noUser = false;
                }
                _this.userList.forEach(function (i) { i.userFirstName = i.userFirstName + " " + i.userLastName; });
            }
            _this.peopleSearchLoading = false;
            _this.spinner.hide();
        }, function (err) {
            _this.peopleSearchLoading = false;
            _this.spinner.hide();
            if (err && err.value && err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    PushNotificationComponent.prototype.userSelection = function ($event) {
        var _this = this;
        if (!$event || !$event.emailId) {
            return;
        }
        this.userExists = false;
        this.userFound = false;
        this.searchTerm = '';
        var email = $event.emailId.trim().toLowerCase();
        var alreadySelected = this.selectedEmail.some(function (value) { return value.trim().toLowerCase() === email; })
            || this.selectedUserList.some(function (user) { return user.emailId.trim().toLowerCase() === email; });
        if (!alreadySelected) {
            // val not found, pushing onto array
            this.selectedUserList.push($event);
            this.userFirstName = '';
            this.userList = [];
            this.search = false;
            // ng-select retains internal selected-item state independent of ngModel; clear it explicitly
            setTimeout(function () { return _this.userSelect && _this.userSelect.clearModel(); }, 0);
        }
        else {
            this.userExists = true;
            this.userFound = false;
        }
    };
    PushNotificationComponent.prototype.removeUser = function (emailId) {
        this.selectedUserList = this.selectedUserList.filter(function (user) { return user.emailId !== emailId; });
        this.search = false;
    };
    PushNotificationComponent.prototype.resetSelectedUser = function () {
        this.selectedUserList = [];
        this.userFound = false;
        this.searchTerm = null;
        this.userList = null;
        this.userFirstName = '';
        this.search = false;
        this.userExists = false;
        this.peopleSearchLoading = false;
    };
    PushNotificationComponent.prototype.addUserToList = function () {
        this.userExists = false;
        this.method = "addUsersToEmailList";
        this.param = '';
        this.msg1 = 'Are you sure you want to add the selected user(s) to the recipient list?';
    };
    PushNotificationComponent.prototype.addUsersToEmailList = function () {
        var _this = this;
        if (this.recipientsLoading || this.recipientsLoadError || this.isSending) {
            return;
        }
        var _loop_1 = function (user) {
            var email = (user.emailId || '').trim();
            var key = email.toLowerCase();
            if (!email || this_1.selectedEmail.some(function (value) { return value.trim().toLowerCase() === key; })) {
                return "continue";
            }
            var existing = this_1.emailList.find(function (item) { return item.emailId.trim().toLowerCase() === key; });
            if (!existing) {
                this_1.emailList = this_1.emailList.concat([{ userId: user.userId, emailId: email }]);
                if (this_1.manualEmails.indexOf(key) === -1) {
                    this_1.manualEmails.push(key);
                }
            }
            this_1.selectedEmail = this_1.selectedEmail.concat([existing ? existing.emailId : email]);
        };
        var this_1 = this;
        for (var _i = 0, _a = this.selectedUserList; _i < _a.length; _i++) {
            var user = _a[_i];
            _loop_1(user);
        }
        this.openAndCloseMatDialog('close');
        this.usersAdded = true;
        this.noMemberFound = false;
        setTimeout(function () { return _this.usersAdded = false; }, 3000);
    };
    PushNotificationComponent.prototype.deleteFile = function (d) {
        var index = this.fileList.indexOf(d);
        if (index !== -1) {
            this.fileList.splice(index, 1);
        }
        this.updateFileState();
    };
    PushNotificationComponent.prototype.findbyEmail = function (e) {
        var text = e.target.value;
        if (text.length > 2) {
            this.searchTerm = text;
            this.searchBy();
        }
        else {
            this.userList = [];
            this.noUser = false;
            this.userFound = false;
            this.peopleSearchLoading = false;
        }
    };
    /** For capturing files detail
  * @class PushNotificationComponent
  * @method onFileSelected
  */
    PushNotificationComponent.prototype.onFileSelected = function (event) {
        var allowedExtensions = ["jpg", "jpeg", "png", "pdf", "ppt", "pptx", "txt", "doc", "docx", "xlsx", "csv"];
        var maxTotalSize = 524288000;
        var selectedFiles = Array.prototype.slice.call(event.target.files || []);
        this.attachmentWarnings = [];
        var runningTotal = this.fileList.reduce(function (size, file) { return size + file.size; }, 0);
        var acceptedFiles = [];
        var _loop_2 = function (file) {
            var extension = file.name.split('.').pop().toLowerCase();
            if (allowedExtensions.indexOf(extension) === -1) {
                this_2.attachmentWarnings.push(file.name + ": unsupported file type; not added.");
                return "continue";
            }
            if (runningTotal + file.size > maxTotalSize) {
                this_2.attachmentWarnings.push(file.name + ": exceeds the 500 MB total limit; not added.");
                return "continue";
            }
            if (this_2.fileList.concat(acceptedFiles).some(function (existing) { return existing.name === file.name; })) {
                this_2.attachmentWarnings.push(file.name + ": a file with this name is already selected; not added.");
                return "continue";
            }
            runningTotal += file.size;
            acceptedFiles.push(file);
        };
        var this_2 = this;
        for (var _i = 0, selectedFiles_1 = selectedFiles; _i < selectedFiles_1.length; _i++) {
            var file = selectedFiles_1[_i];
            _loop_2(file);
        }
        this.fileList = this.fileList.concat(acceptedFiles);
        this.updateFileState();
        event.target.value = '';
    };
    PushNotificationComponent.prototype.updateFileState = function () {
        this.fileSize = this.fileList.reduce(function (size, file) { return size + file.size; }, 0);
        this.fileName = this.fileList.length ? this.fileList.map(function (file) { return file.name; }).join(' , ') : this.fileSizeConstant;
        this.fileSizeExtensionError = this.fileSize > 524288000;
        this.fileExtensionError = false;
    };
    /**To reset notification
   * @class PushNotificationComponent
   * @method resetClick
   */
    PushNotificationComponent.prototype.resetClick = function () {
        this.method = "resetClickConfirmation";
        this.param = '';
        this.msg1 = "Your current changes will be discarded. Do you want to continue?";
    };
    /**To reset notification on confirmation
  * @class PushNotificationComponent
  * @method resetClickConfirmation
  */
    PushNotificationComponent.prototype.resetClickConfirmation = function () {
        this.siteRequestId++;
        this.clearAudienceRecipients();
        this.review = null;
        this.attachmentWarnings = [];
        this.sendStatus = '';
        this.startDateGreaterError = false;
        this.noMemberFound = false;
        this.copySuccess = false;
        this.copyFailure = false;
        this.usersAdded = false;
        this.showJoinedDateField = false;
        this.showCustomDateRange = false;
        this.selectedFilter = null;
        this.startDate = null;
        this.endDate = null;
        this.bpgId = null;
        this.chapterNotification = '';
        this.subject = '';
        this.fileName = this.fileSizeConstant;
        this.fileList = [];
        this.fileSize = 0;
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.notificationSuccess = false;
        this.notificationFailure = false;
        this.recipientsLoading = false;
        this.peopleSearchLoading = false;
        this.isSending = false;
        this.selectedSiteIds = [];
        this.siteId = null;
        this.siteList = [];
        this.errorMsg = '';
        this.selectedEmail = [];
        this.emailList = [];
        this.recipientType = 'MEMBERS';
        this.allSitesSelected = false;
        this.spinner.hide();
    };
    /**To send Notification
  * @class PushNotificationComponent
  * @method sendNotification
  */
    PushNotificationComponent.prototype.sendNotification = function () {
        var _this = this;
        if (this.isSending || this.reviewDialogRef || this.sendBlockers.length > 0) {
            return;
        }
        this.notificationFailure = false;
        this.notificationSuccess = false;
        this.errorMsg = '';
        this.sendStatus = '';
        this.review = Object.freeze({
            userId: this.loginDetails.userId,
            subject: this.subject,
            body: this.chapterNotification,
            bpgId: String(this.bpgId),
            siteIds: Object.freeze(this.selectedSiteIds.slice()),
            emails: Object.freeze(this.selectedEmail.slice()),
            files: Object.freeze(this.fileList.slice()),
            audience: this.audienceSummary,
            audienceParts: this.buildAudienceSummaryParts(),
            manualEmails: Object.freeze(this.selectedEmail.filter(function (email) { return _this.isManualEmail(email); }))
        });
        var config = new MatDialogConfig();
        config.width = '960px';
        config.maxWidth = 'calc(100vw - 32px)';
        config.maxHeight = 'calc(100vh - 32px)';
        config.autoFocus = true;
        config.ariaLabelledBy = 'notification-review-title';
        config.panelClass = 'pn-dialog-panel';
        config.backdropClass = 'pn-dialog-backdrop';
        this.reviewDialogRef = this.dialog.open(this.reviewDialog, config);
        this.reviewDialogRef.afterClosed().subscribe(function () {
            _this.review = null;
            _this.reviewDialogRef = null;
        });
    };
    PushNotificationComponent.prototype.closeReview = function () {
        if (!this.isSending && this.reviewDialogRef) {
            this.reviewDialogRef.close();
        }
    };
    /**To send Notification on confirmation
  * @class PushNotificationComponent
  * @method onsendNotification
  */
    PushNotificationComponent.prototype.onsendNotification = function () {
        var _this = this;
        var reviewed = this.review;
        if (this.isSending || this.notificationFailure || !reviewed || this.validateNotification(reviewed).length > 0) {
            return;
        }
        this.isSending = true;
        this.reviewDialogRef.disableClose = true;
        this.sendStatus = 'Submitting notification…';
        this.spinner.show();
        this.copySuccess = false;
        this.copyFailure = false;
        var notificationData = {
            "userId": reviewed.userId,
            "notificationDesc": reviewed.body,
            "siteId": reviewed.siteIds,
            "bpgId": reviewed.bpgId,
            "fileNameList": reviewed.files.map(function (file) { return file.name; }),
            "subject": reviewed.subject,
            "serviceFunction": 'saveData',
            "emailIdTo": reviewed.emails.join(',')
        };
        this.selfService.sendChapterNotification(notificationData).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            var notificationId, _a, _i, _b, file, fileResponse, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 8, 9, 10]);
                        if (!data || data.message || data.body == null) {
                            throw new Error((data && data.message) || 'Failed to send the notification');
                        }
                        notificationId = data.body.notificationId;
                        if (!reviewed.files.length) return [3 /*break*/, 7];
                        if (notificationId == null || !Number.isInteger(Number(notificationId)) || Number(notificationId) <= 0) {
                            throw new Error('The server did not return a valid notification ID. Attachments were not uploaded.');
                        }
                        localStorage.removeItem('uploadError');
                        _a = this;
                        return [4 /*yield*/, this.bpgCommonService.getAwsUrl({ category: 'uploadDocument' }).toPromise()];
                    case 1:
                        _a.awsUrls = _c.sent();
                        _i = 0, _b = reviewed.files;
                        _c.label = 2;
                    case 2:
                        if (!(_i < _b.length)) return [3 /*break*/, 5];
                        file = _b[_i];
                        this.sendStatus = "Uploading " + file.name + "\u2026";
                        return [4 /*yield*/, this.uploadService.getPresignedUrl(file, this.awsUrls, Number(notificationId), 'chapter_notification')];
                    case 3:
                        _c.sent();
                        if (localStorage.getItem('uploadError') === 'Error') {
                            localStorage.removeItem('uploadError');
                            throw new Error('Failed to send the notification');
                        }
                        _c.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        this.sendStatus = 'Finalizing notification…';
                        return [4 /*yield*/, this.selfService.sendChapterNotification({
                                "notificationId": notificationId,
                                "serviceFunction": "savefile",
                                "emailIdTo": reviewed.emails.join(','),
                                "siteId": reviewed.siteIds,
                                "bpgId": reviewed.bpgId,
                            }).toPromise()];
                    case 6:
                        fileResponse = _c.sent();
                        if (!fileResponse || fileResponse.message || fileResponse.body == null) {
                            throw new Error((fileResponse && fileResponse.message) || 'Failed to send the notification');
                        }
                        _c.label = 7;
                    case 7:
                        this.isSending = false;
                        this.closeReview();
                        this.resetClickConfirmation();
                        this.notificationSuccess = true;
                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                        return [3 /*break*/, 10];
                    case 8:
                        error_1 = _c.sent();
                        this.errorMsg = error_1.message || 'Failed to send the notification';
                        this.notificationSuccess = false;
                        this.notificationFailure = true;
                        return [3 /*break*/, 10];
                    case 9:
                        this.isSending = false;
                        this.sendStatus = '';
                        if (this.reviewDialogRef) {
                            this.reviewDialogRef.disableClose = false;
                        }
                        this.spinner.hide();
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        }); }, function (error) {
            _this.errorMsg = error.message || 'Failed to send the notification';
            _this.notificationSuccess = false;
            _this.notificationFailure = true;
            _this.isSending = false;
            _this.sendStatus = '';
            if (_this.reviewDialogRef) {
                _this.reviewDialogRef.disableClose = false;
            }
            _this.spinner.hide();
        });
    };
    PushNotificationComponent.prototype.logUserAction = function () {
        var data = {
            userId: this.loginUserId,
            categoryDescription: "Push Notification"
        };
        this.bpgCommonService.logUserAction(data).subscribe(function (_data) { });
    };
    PushNotificationComponent.prototype.navigateToPushNotificationLogs = function () {
        this.router.navigate(['/push-notification-logs']);
    };
    return PushNotificationComponent;
}());
export { PushNotificationComponent };
